declare namespace $ {

	type $mol_link_source__uri_brand_app_color_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_switch__value_brand_app_color_2 = $mol_type_enforce<
		ReturnType< $brand_app_color['color'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_brand_app_color_3 = $mol_type_enforce<
		ReturnType< $brand_app_color['colors'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_link_iconed__title_brand_app_color_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['title'] >
	>
	type $mol_link_iconed__uri_brand_app_color_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_iconed['uri'] >
	>
	type $mol_text__text_brand_app_color_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_brand_app_color_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_brand_app_color_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__hint_brand_app_color_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_text__text_brand_app_color_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_brand_app_color_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	export class $brand_app_color extends $mol_page {
		GitHub( ): $mol_link_source
		color( next?: string ): string
		colors( ): ({ 
			'mol': string,
			'custom': string,
			'bootstrap': string,
			'mui': string,
			'vuetify': string,
			'ant': string,
		}) 
		Themes_switcher( ): $mol_switch
		Theme_link( ): $mol_link_iconed
		Themes( ): $mol_text
		Keys( ): $mol_text
		Source( ): $mol_text
		Target( ): $mol_string
		Formula( ): $mol_text
		Result( ): $mol_text
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=color.view.tree.d.ts.map